import Vue from "vue"
import Vuelidate from "vuelidate"
import App from "./App.vue"
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css"
import "@mdi/font/css/materialdesignicons.css"
import router from "./router"
import axios from "axios"
import VueAxios from "vue-axios"
import store from "./store"
import Moment from "moment"
import VTooltip from 'v-tooltip';

import "./events/global.event.bus"

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(VTooltip);
Vue.use(Vuelidate)
Vue.use(VueAxios, axios)

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App),
    created() {
        Moment.locale("ru");
    }
}).$mount("#app")
